/**
 * Vloeiend open- en dichtklappen van de FAQ-items.
 *
 * <details> animeert van zichzelf niet: zodra het open-attribuut verdwijnt zet
 * de browser de inhoud op display:none, en daar valt niets aan te interpoleren.
 * Daarom nemen we de klik over: bij openen zetten we het attribuut meteen en
 * animeren we de hoogte van 0 naar de inhoudshoogte; bij sluiten animeren we
 * eerst terug naar 0 en halen we het attribuut pas weg als de overgang klaar is.
 *
 * Zonder JavaScript blijft het element gewoon werken — dan klapt het alleen
 * direct open en dicht in plaats van vloeiend.
 *
 * Twee dingen die hier makkelijk misgaan:
 *
 * 1. De `transition` staat in de CSS en niet hier. Wordt hij in dezelfde frame
 *    gezet als de nieuwe hoogte, dan is er voor de browser geen "waarde ervoor"
 *    en start er geen overgang — waarna transitionend nooit vuurt.
 * 2. Tussen de begin- en eindhoogte moet een geforceerde herberekening zitten,
 *    anders ziet de browser alleen de eindwaarde en springt het paneel.
 */

const DUUR = 300;

function animeer(item, paneel, van, naar, klaar) {
  let afgerond = false;

  const afronden = () => {
    if (afgerond) return;
    afgerond = true;

    clearTimeout(vangnet);
    paneel.removeEventListener('transitionend', opOvergang);

    // Eerst afsluiten, dan pas de hoogte vrijgeven. Andersom staat het paneel
    // één frame op `auto` terwijl het nog zichtbaar is, en dat is precies de
    // schok die je ziet aan het eind van het dichtklappen.
    if (klaar) klaar();

    paneel.style.height = '';
    delete item.dataset.animeert;
  };

  const opOvergang = (event) => {
    // transitionend bubbelt ook vanuit de inhoud; alleen het paneel telt.
    if (event.target === paneel && event.propertyName === 'height') afronden();
  };

  // Vangnet: gaat de overgang om welke reden dan ook niet door, dan moet het
  // item niet voorgoed op slot blijven staan.
  const vangnet = setTimeout(afronden, DUUR + 100);

  paneel.addEventListener('transitionend', opOvergang);

  paneel.style.height = van;
  void paneel.offsetHeight; // herberekening forceren, zodat `van` telt als startwaarde
  paneel.style.height = naar;
}

function koppel(item) {
  const vraag = item.querySelector('.lp-faq__vraag');
  const paneel = item.querySelector('.lp-faq__antwoord');

  if (!vraag || !paneel) return;

  vraag.addEventListener('click', (event) => {
    // Respecteer de systeeminstelling voor minder beweging: dan laten we de
    // browser gewoon zijn eigen ding doen.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    event.preventDefault();

    if (item.dataset.animeert === '1') return;
    item.dataset.animeert = '1';

    if (item.open) {
      animeer(item, paneel, `${paneel.scrollHeight}px`, '0px', () => {
        item.open = false;
      });
    } else {
      item.open = true;
      animeer(item, paneel, '0px', `${paneel.scrollHeight}px`);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-faq__item').forEach(koppel);
});
